import { render, staticRenderFns } from "./orderYdgshenpi.vue?vue&type=template&id=83767834&scoped=true"
import script from "./orderYdgshenpi.vue?vue&type=script&lang=js"
export * from "./orderYdgshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderYdgshenpi.vue?vue&type=style&index=0&id=83767834&prod&scoped=true&lang=css"
import style1 from "./orderYdgshenpi.vue?vue&type=style&index=1&id=83767834&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83767834",
  null
  
)

export default component.exports